module.exports = __webpack_public_path__ + "static/media/game.3511cece.png";